import React from 'react';
import {
  Breadcrumb as BsBreadcrumb,
  BreadcrumbItem as BsBreadcrumbItem,
  BreadcrumbItemProps as BsBreadcrumbItemProps,
  BreadcrumbProps as BsBreadcrumbProps,
} from 'react-bootstrap';

export type BreadCrumbItemProps = Omit<
  BsBreadcrumbItemProps,
  'children' | 'as' | 'href'
>;
export type MasterProps = Omit<BsBreadcrumbProps, 'children' | 'href'>;
/** 顯示的資料
 * children 內容
 * href 連結
 * active 增加color(#adb5bd)
 * as 可轉成其他的HTML Tag 預設<li>
 * style CSS
 * target 設定鏈結打開方式
 */
export interface IBreadCrumbData {
  children: React.ReactNode;
  href?: string;
  active?: boolean;
  as?: React.ElementType;
  style?: React.CSSProperties;
  target?: '_blank' | '_self' | '_parent' | '_top	';
}
export interface BreadCrumbProps {
  data: IBreadCrumbData[];
  /** <ol>的Style */
  style?: React.CSSProperties;
  /** <li>的Style，如要個別設定可再data的style裡調整 */
  listStyle?: React.CSSProperties;
  /** React Bootsrap原生屬性，請參考 https://react-bootstrap.github.io/components/breadcrumb/#breadcrumb-props */
  masterProps?: MasterProps;
  /** React Bootsrap原生屬性，請參考 https://react-bootstrap.github.io/components/breadcrumb/#breadcrumb-item-props */
  itemProps?: BreadCrumbItemProps;
}
const BreadCrumb = (props: BreadCrumbProps) => {
  const {
    data: BreadCrumbData = [],
    masterProps,
    itemProps,
    style,
    listStyle,
  } = props;

  return (
    <BsBreadcrumb style={style} {...masterProps}>
      {BreadCrumbData.map((obj, i) => {
        const { href, active, as, target, children } = obj;
        return (
          <BsBreadcrumbItem
            key={String(i + 1)}
            style={{ ...listStyle, ...obj.style }}
            {...{ active, as, target, href, ...itemProps }}
          >
            {children}
          </BsBreadcrumbItem>
        );
      })}
    </BsBreadcrumb>
  );
};

export default BreadCrumb;
